// import { CHECKMATE_PLUS_URL } from 'shared/constants';

export type NavItem = {
  titleKey: string;
  to?: string;
  target?: string;
  showNewBadge?: boolean;
  gaLabel?: string;
  subMenu?:
    | {
        titleKey: string;
        to: string;
        target?: string;
        gaLabel?: string;
        // SPA 라우터가 아닌 브라우저 full navigation 으로 처리 (CloudFront origin 라우팅용)
        external?: boolean;
      }[]
    | 'services';
};

export const NavList: NavItem[] = [
  {
    titleKey: 'common:navigation.roomsearch',
    to: '/listing',
    gaLabel: 'Room Search',
  },
  {
    titleKey: 'common:navigation.services',
    subMenu: 'services', // Special dropdown menu
  },
  {
    titleKey: 'common:navigation.checkmatemall',
    to: '/checkmate-mall',
    showNewBadge: true,
    gaLabel: 'Checkmate Mall',
  },
  {
    titleKey: 'common:navigation.guide',
    gaLabel: 'Guide',
    subMenu: [
      {
        titleKey: 'common:navigation.bookingguide',
        to: '/guide',
        gaLabel: 'Booking Guide',
      },
      {
        titleKey: 'common:navigation.koreanhousinginfo',
        to: '/korean-housing-info',
        gaLabel: 'Korean Housing Info',
      },
      {
        titleKey: 'common:navigation.blog',
        to: '/blog/',
        gaLabel: 'Blog',
        external: true,
      },
    ],
  },
  {
    titleKey: 'common:navigation.aboutus',
    gaLabel: 'About Us',
    subMenu: [
      {
        titleKey: 'common:navigation.aboutcheckmate',
        to: '/about-us',
        gaLabel: 'About Checkmate',
      },
      {
        titleKey: 'common:navigation.reviews',
        to: '/reviews',
        gaLabel: 'Reviews',
      },
    ],
  },
];
